export var CHANGE_APPLY_METHOD = {
    OPEN_MODAL: 'TOGGLE_APPLICABLE_MODAL',
    CLOSE_MODAL: 'CLOSE_APPLICABLE_MODAL',
    AFTER_SAVE: 'SAVED_APPLICABLE_DATA',
    GET_DATA: 'GET_APPLICABLE_DATA',
    UPDATE_DATA: 'UPDATE_APPLICABLE_DATA',
};
//# sourceMappingURL=change-apply-method.js.map